import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Toasted from "vue-toasted";
import AuthCallback from '../components/AuthCallback.vue'

Vue.use(Toasted);
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/AuthCallback",
    name: "AuthCallback",
    component: AuthCallback,
    meta: {
      requireAuth: false
    }
  },
  {
    // `:id?` is intentionally optional. PhotoSelector on the home page routes
    // to /edit before the user has chosen a target machine — they pick one via
    // the embedded Search component inside PhotoUploader. The previous `/edit/:id`
    // pattern emitted a vue-router warning on that navigation ("missing param
    // for named route 'PhotoUploader': Expected 'id' to match ...") three times
    // per click. Navigation worked anyway, but this cleans up the console.
    path: "/edit/:id?",
    name: "PhotoUploader",
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "@/components/PhotoUploader.vue"),
      meta: {
          requireAuth: true,
        keepAlive:false
      }
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
    routes,
    scrollBehavior()
    {
        return { x: 0, y: 0 }
    }
});

export default router;